import React from "react";
import { TodoContext } from "../../Utils/TodoContext";
import './TodoSearch.css';
import { FcClearFilters } from "react-icons/fc";

// export class searchState {
//   public searchValue: string;
//   public setSearchValue: any;

//   constructor(data: searchState) {
//     this.searchValue = data.searchValue;
//     this.setSearchValue = data.setSearchValue;
//   }
// }


function TodoSearch() {
  const { searchValue, setSearchValue }: any = React.useContext(TodoContext);

  const onSearchValueChange = (event: any) => {
    setSearchValue(event.target.value);
  };

  const onClickClearButton = () => {
    setSearchValue("");
  };

  return (
    <div className="searchSection">
      <input
        className="TodoSearch"
        placeholder="Search a todo..."
        value={searchValue}
        onChange={onSearchValueChange}
      />
      <button
        className="clearButton"
        onClick={onClickClearButton}
        >
        <FcClearFilters />
      </button>
    </div>
  );
}

export { TodoSearch };